import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-our-projects',
  templateUrl: './our-projects.component.html',
  styleUrls: ['./our-projects.component.css'],
})
export class OurProjectsComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  groupedServices: any = [];

  ngOnInit(): void {
    this.updateGroupedServices();
  }

  groupArray<T>(arr: T[], chunkSize: number): T[][] {
    const groups: T[][] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      groups.push(arr.slice(i, i + chunkSize));
    }
    return groups;
  }

  updateGroupedServices() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 767) {
      this.groupedServices = this.groupArray(this.data.details.services, 6);
    } else if (screenWidth >= 576 && screenWidth < 767) {
      this.groupedServices = this.groupArray(this.data.details.services, 4);
    } else if (screenWidth < 576) {
      this.groupedServices = this.groupArray(this.data.details.services, 1);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateGroupedServices();
  }

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
